import { render, staticRenderFns } from "./AddEditUser.vue?vue&type=template&id=764b48e3&scoped=true"
import script from "./AddEditUser.vue?vue&type=script&lang=js"
export * from "./AddEditUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764b48e3",
  null
  
)

export default component.exports